import { jsx } from '@amzn/shiv'
import { Icon } from '@/components/Icon'

export function ImagePlaceholder() {
    return (
        <div className={'iconImagePlaceholder'}>
            <Icon icon="album" />
        </div>
    )
}
